import { render, staticRenderFns } from "./orderBox.vue?vue&type=template&id=bc671208&scoped=true"
import script from "./orderBox.vue?vue&type=script&lang=js"
export * from "./orderBox.vue?vue&type=script&lang=js"
import style0 from "./orderBox.vue?vue&type=style&index=0&id=bc671208&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc671208",
  null
  
)

export default component.exports